import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: []
})
export class DashboardPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
